import { NavigationGuard } from "vue-router";
import { usuarioStorage } from "@/store/usuario/UsuarioStorage";

export const PORTAL_URL =
  process.env.VUE_APP_PORTAL_URL || "http://portal.genteseguradora.com.br/";

export const loginDesativado: NavigationGuard = (to, from, next) => {
  if (!!usuarioStorage.getData()) {
    next({ name: "HomePage" });
    return;
  }
  next(false);
  window.location.replace(PORTAL_URL);
};
